import { createSlice } from "@reduxjs/toolkit";

const tabsSlice = createSlice({
  name: "tabs",
  initialState: {
    selectedTab: "settlement",
    selectedTabDates: { settlementFrom: null, settlementTo: null },
  },
  reducers: {
    setSelectedTab: (state, action) => {
      state.selectedTab = action.payload;
    },
    setSelectedTabDates: (state, action) => {
      state.selectedTabDates = action.payload;
    },
  },
});

export const { setSelectedTab, setSelectedTabDates } = tabsSlice.actions;
export default tabsSlice.reducer;
